import { IconProps } from "../../../types/style";

const LogoutSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.6 29.3333H13.0667C17.3333 29.3333 20 26.6666 20 22.3999V16.9999H14.08L16.84 19.7599C17.04 19.9599 17.1333 20.2133 17.1333 20.4666C17.1333 20.7199 17.04 20.9733 16.84 21.1733C16.4533 21.5599 15.8133 21.5599 15.4267 21.1733L10.96 16.7066C10.5733 16.3199 10.5733 15.6799 10.96 15.2933L15.4267 10.8266C15.8133 10.4399 16.4533 10.4399 16.84 10.8266C17.2267 11.2133 17.2267 11.8533 16.84 12.2399L14.08 14.9999H20L20 9.59992C20 5.33325 17.3333 2.66659 13.0667 2.66659H9.61333C5.34667 2.66659 2.68 5.33325 2.68 9.59992L2.68 22.3999C2.66667 26.6666 5.33333 29.3333 9.6 29.3333Z"
          fill={color}
        />
        <path
          d="M28.3333 17C28.8799 17 29.3333 16.5467 29.3333 16C29.3333 15.4533 28.8799 15 28.3333 15L19.9999 15V17H28.3333Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default LogoutSVG;
